<div class="modal-header justify-content-between align-items-center">
    <h5 class="modal-title">{{ fieldName | translate }}</h5>
    <a class="cursor" data-dismiss="modal" (click)="abort()"> <img src="assets/ph-bhp-layout/svg/remove.svg"> </a>
</div>

<div class="modal-body overflow-auto">
    <div class="col-12 p-0">
        <div *ngFor="let lang of data | keyvalue">
            <div class="bd-input w-100" *ngIf="!isMultiLine" [ngClass]="i==0? 'mt-4': 'mt-5'">
                <input id="input-{{lang.key}}" inputSanitizer type="text" [maxlength]="maxlength"
                    [(ngModel)]="lang.value.currentValue" placeholder="{{'DIALOG.TRANSLATE.WRITE_HERE' | translate}}">
                <label for="input-{{lang.key}}" class="label" [ngClass]="lang.value.currentValue ? 'filled':'' ">{{
                    'DIALOG.TRANSLATE.LANGUAGE_LABEL' | translate}}: {{ lang.key }}</label>
            </div>
            <div class="bd-input comments-container w-100" *ngIf="isMultiLine"
                [ngClass]="i==0? 'my-4': 'my-5'">
                <textarea id="textComment-{{lang.key}}" inputSanitizer class="text-comt form-control"
                    [ngClass]="lang.value.currentValue ? 'filled':'' " [(ngModel)]="lang.value.currentValue" rows="1"
                    type="text" [maxlength]="maxlength"
                    placeholder="{{'DIALOG.TRANSLATE.WRITE_HERE' | translate}}"></textarea>
                <label for="textComment-{{lang.key}}" class="label">{{ 'DIALOG.TRANSLATE.LANGUAGE_LABEL' | translate}}:
                    {{ lang.key }}</label>
            </div>
        </div>
    </div>
</div>

<div class="modal-footer">
    <div class="justify-content-center align-items-end d-flex w-100">
        <button type="button" class="btn-bd-empty w-100" (click)="confirm()">{{ 'AUTHORIZATION.SAVE' | translate
            }}</button>
    </div>
</div>